import React, { useEffect, useRef, useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import axios from "axios";
import exportToExcel from "../Report/ExportExcel";

const passengerTableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "20px",
};

const thTdStyle = {
  padding: "8px",
  border: "1px solid #ddd",
  textAlign: "left",
};

const thStyle = {
  backgroundColor: "#f2f2f2",
};

const Passenger = ({ prRef }) => {
  const [data, setData] = useState([]);

  const renderCellValue = (value) => {
    if (value === null || value === undefined) return "";
    if (typeof value === "object") {
      return (
        value.company_name ||
        value.companyName ||
        value.name ||
        value.id ||
        JSON.stringify(value)
      );
    }
    return String(value);
  };

  const getPassengers = async () => {
    const response = await axios.get("passengers/").catch((err) => {});
    if (response && response.data) {
      setData(response.data);
    }
  };

  useEffect(() => {
    getPassengers();
  }, []);

  const columns =
    data.length > 0
      ? Object.keys(data[0]).filter((column) => column !== "passengerImage")
      : [];

  return (
    <div ref={prRef}>
      <Header
        title={"Passengers Information"}
        subTitle={""}
      />
      <div></div>
      <table style={passengerTableStyle}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column} style={{ ...thTdStyle, ...thStyle }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {columns.map((column) => (
                <td key={column} style={thTdStyle}>
                  {renderCellValue(row[column])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <Footer />
    </div>
  );
};

export default Passenger;

export const exportExcelPassengers = async () => {
  const getPassengers = async () => {
    const response = await axios.get("passengers/").catch((err) => {});
    if (response && response.data) {
      exportToExcel(response.data, "passenger");
    }
  };

  getPassengers();
};
